import React, { useEffect, useState } from "react";

import closeDarkIcon from "../../../assets/img/icons/closeDarkIcon.svg";
import { useSiteData } from "../../../contexts/SiteDataContext";
import { useLocalized } from "../../../i18n/localized";

export default function VolatileNotice() {
  const { siteData } = useSiteData();
  const text = useLocalized();
  const notice = text(siteData?.volatile_notice, "content");
  const [isVisible, setIsVisible] = useState(() => {
    const isClosed = localStorage.getItem("volatile_notice_closed3");
    return isClosed !== "true";
  });
  const [isButtonReady, setIsButtonReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsButtonReady(true);
    }, 1700);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem("volatile_notice_closed3", "true");
    window.umami?.track("volatile_notice_closed");
  };

  if (!isVisible || !notice) {
    return null;
  }

  return (
    <div className="flex flex-col flex-1">
      <div className="container-md mx-auto relative 2xl:px-0 lg:px-4 md:px-4 px-4 py-4">
        <div className="bg-yellow-2 p-7 rounded-2xl relative md:pr-16">
          <div
            className="absolute top-0 right-0 cursor-pointer p-4"
            style={{
              opacity: isButtonReady ? 1 : 0.05,
              pointerEvents: isButtonReady ? "auto" : "none",
              transition: "opacity 0.3s ease",
            }}
            onClick={handleClose}
          >
            <img
              className="w-[0.79rem]"
              src={closeDarkIcon}
              alt="Close notice"
            />
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: notice,
            }}
          />
        </div>
      </div>
    </div>
  );
}
